import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ag-shimmer-loader',
  templateUrl: './shimmer-loader.component.html',
  styleUrls: ['./shimmer-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ShimmerLoaderComponent {}
